<input type="hidden" name="menuType" id="menuType" value="secure" />
<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <h2 id="pageTitle">{{'bss.roleManagement.title'| translate}}</h2>
    <hr>
  </div>
</div>


<div *ngIf="appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId" #pageMsg>
  <div class="ontario-columns">
    <div class="ontario-alert ontario-alert--error ">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
      </div>
      <div class="ontario-alert__body">
        <p>{{appErrorMessage}}</p>
      </div>
    </div>
  </div>
</div>

<div class="ontario-row">
  <div class="ontario-column ontario-small-12">

    <div class="ontario-columns" tabindex="101">
      <h4>{{'bss.roleManagement.subTitle'| translate}}</h4>
      <ol>
        <li *ngFor="let role of roles ;let i = index">{{ role }}</li>
      </ol>
      <button tabindex="102" class="ontario-button ontario-button--primary" (click)="viewProfile()"
        title=" {{'bss.roleManagement.goback.title' | translate }}">
        {{'bss.roleManagement.goback' | translate }}
      </button>
    </div>

  </div>
</div>